import { getLoggedInUserInfo } from './helper';
const AFFILIATE_NUMBER = 130;

const eventNames = {
  addToCart: 'cart_addition',
  search: 'onsite_search',
  productView: 'product_view',
  productListView: 'product_list_view',
  purchase: 'purchase',
  share: 'share'
};

const ttqEventNames = {
  addToCart: 'AddToCart',
  InitiateCheckout: 'InitiateCheckout',
  CompletePayment: 'CompletePayment'
};

const LINK_EVENTS = [eventNames.addToCart];

const trackEvent = (eventName, data) => {
  if (typeof window === 'undefined') return;
  if (!window.utag) return;

  const authDetails = getAuthDetails();

  try {
    if (LINK_EVENTS.some(ev => ev === eventName)) {
      return window.utag.link({
        ...window.utag_data,
        ...authDetails,
        ...{
          ...(eventName && { event_name: eventName }),
          ...data,
        },
      });
    }

    return window.utag.view({
      ...window.utag_data,
      ...authDetails,
      ...{
        ...(eventName && { event_name: eventName }),
        ...data,
      },
    });
  } catch (err) {
    console.log(err);
  }
};

const ttqTrackEvent = (eventName, data) => {
  if (typeof window === 'undefined') return;
  if (!window.ttq) return;
  try {
    return window.ttq.track(eventName, data)
  } catch (error) {
    console.log(error);
  }
}

export const trackPage = type => {
  if (!type) return;
  return trackEvent(undefined, {
    ...getPageDetails({ type }),
  });
};
//加入购物车
export const trackAddToCart = async (products = [], quantities = [], pageDetails) => {
  if (!products || !quantities) return;
  /*FB_Meta*/
  if (typeof window !== "undefined" && typeof window.fbq !== "undefined") {
    fbq('track', 'AddToCart');
  }
  /*FB_Meta*/
  return trackEvent(eventNames.addToCart, {
    cart_type: getCartTypes(products),
    product_brand: getProductBrands(products),
    product_businessVolume: getProductBVs(products),
    product_id: getProductIds(products),
    product_name: getProductNames(products),
    product_pointValue: getProductPVs(products),
    product_unitPrice: getProductPrices(products),
    product_units: quantities.map(massageAttrVal),
    ...getPageDetails(pageDetails),
  });
};

//   TEP-15578  ｜  TIKTOK  |  事件埋点
export const ttqTrackEventBuryingPoint = (eventNames, products) => {
  if (!products) return;
  return ttqTrackEvent(ttqEventNames[eventNames], {
    value: getOrderPrice(products),
    currency: 'NTD',
    contents: getOrderproductInfo(products)
  })
}
//    订单总价
const getOrderPrice = (products) => {
  // 使用reduce方法来计算总价  
  const total = products.reduce((accumulator, item) => {
    // 累加器累加每个商品的单价乘以数量  
    return accumulator + (item?.price * item?.quantity);
  }, 0); // 初始值设置为0  

  return total; // 返回计算得到的总价 
}
//   订单商品明细
const getOrderproductInfo = (products) => {
  if (products.length == 0) return [];
  const contents = []
  products.map((item) => {
    let json = {}
    json.content_id = item?.itemCode;
    json.content_type = item?.productBrand ? item?.productBrand : item?.skuName;
    json.content_name = item?.productName ? item?.productName : item?.productNameEn;
    json.price = item?.price;
    json.quantity = item?.quantity;
    contents.push(json)
  })

  return contents
}
//搜索商品
export const trackSearch = (keyword, resultCount, searchType = 'direct') => {
  if (!keyword) return;
  return trackEvent(eventNames.search, {
    search_keyword: massageAttrVal(keyword),
    search_results: massageAttrVal(resultCount),
    search_type: massageAttrVal(searchType),
    ...getPageDetails({ type: PAGES.search }),
  });
};
//PDP页面
export const trackProductView = ({ product, page }) => {
  if (!product) return;

  return trackEvent(eventNames.productView, {
    product_brand: getProductBrands([product]),
    product_id: getProductIds([product]),
    product_name: getProductNames([product]),
    product_inventoryStatus: getInventoryStatuses([product]),
    product_promo: getProductPromos([product]),
    ...getPageDetails({ type: PAGES.pdp, ...page }),
  });
};
//PLP页面
export const trackProductViewList = ({ products, page }) => {
  if (!products) return;

  return trackEvent(eventNames.productListView, {
    product_brand: getProductBrands(products),
    product_id: getProductIds(products),
    product_name: getProductNames(products),
    product_inventoryStatus: getInventoryStatuses(products),
    product_promo: getProductPromos(products),
    ...getPageDetails({ type: PAGES.plp, ...page }),
  });
};
//  訂單確認_按鈕或頁面
export const trackInitiateCheckout = () => {
  /*FB_Meta*/
  if (typeof window !== "undefined" && typeof window.fbq !== "undefined") {
    fbq('track', 'InitiateCheckout');
  }
}
//创建订单成功
export const trackSubmitOrder = (orderDetails, products) => {
  /*FB_Meta*/
  if (typeof window !== "undefined" && typeof window.fbq !== "undefined") {
    fbq('track', 'Purchase', { value: orderDetails.amountPayable, currency: 'NTD' });
  }
  return trackEvent(eventNames.purchase, {
    order_id: getOrderId(orderDetails),
    order_deliveryMethod: getOrderDeliveryMethod(orderDetails),
    order_paymentType: getOrderPaymentType(orderDetails),
    order_shipping: getOrderShipping(orderDetails),
    order_tax: getOrderTax(orderDetails),

    cart_type: getCartTypes(products),
    product_brand: getProductBrands(products),
    product_id: getProductIds(products),
    product_name: getProductNames(products),
    product_businessVolume: getProductBVs(products),
    product_pointValue: getProductPVs(products),
    product_unitPrice: getProductPrices(products),
    product_transactionId: getProductTransactionIds(products),
    product_purchaser: getOrderPurchaser(products),
    product_units: products.map(product => product.quantity).map(massageAttrVal),
    ...getPageDetails({ type: PAGES.confirmation }),
  });
};
//  Shared via Copy Link from SRP
export const trackSharedCopyLink = (products, search_keyword) => {
  if (!products) return;
  return trackEvent(eventNames.share, {
    share_channel: ["copylink"],
    product_id: getProductIds([products]),
    product_name: getProductNames([products]),
    product_brand: getProductBrands([products]),
    product_businessVolume: getProductBVs([products]),
    product_pointValue: getProductPVs([products]),
    product_unitPrice: getProductPrices([products]),
    ...getSearchKeyword(search_keyword)
  });
}
//  Shared Via Messenger
export const trackSharedViaMessenger = (products, search_keyword) => {
  if (!products) return;
  return trackEvent(eventNames.share, {
    share_channel: ["messenger"],
    product_id: getProductIds([products]),
    product_name: getProductNames([products]),
    product_brand: getProductBrands([products]),
    product_businessVolume: getProductBVs([products]),
    product_pointValue: getProductPVs([products]),
    product_unitPrice: getProductPrices([products]),
    ...getSearchKeyword(search_keyword)
  });
}
//  Shared via Facebook
export const trackSharedViaFacebook = (products, search_keyword) => {
  if (!products) return;
  return trackEvent(eventNames.share, {
    share_channel: ["facebook"],
    product_id: getProductIds([products]),
    product_name: getProductNames([products]),
    product_brand: getProductBrands([products]),
    product_businessVolume: getProductBVs([products]),
    product_pointValue: getProductPVs([products]),
    product_unitPrice: getProductPrices([products]),
    ...getSearchKeyword(search_keyword)
  });
}

//  Shared via Line
export const trackSharedViaLine = (products, search_keyword) => {
  if (!products) return;
  return trackEvent(eventNames.share, {
    share_channel: ["line"],
    product_id: getProductIds([products]),
    product_name: getProductNames([products]),
    product_brand: getProductBrands([products]),
    product_businessVolume: getProductBVs([products]),
    product_pointValue: getProductPVs([products]),
    product_unitPrice: getProductPrices([products]),
    ...getSearchKeyword(search_keyword)
  });
}
const getPageDetails = page => ({
  ...(page?.category && { page_category: massageAttrVal(page?.category) }),
  ...(page?.subCategory && {
    page_subCategory: massageAttrVal(page?.subCategory),
  }),
  ...(PAGE_PROPERTIES[page?.type] || {}),
});

const getAuthDetails = () => {
  const { loginAda, role } = getLoggedInUserInfo();

  if (!loginAda || !role)
    return {
      visitor_userProfile: 'guest',
    };

  return {
    visitor_imcID: getIMCID(loginAda),
    visitor_userProfile: String(role).toLowerCase(),
  };
};

const getSearchKeyword = (search_keyword) => {
  if (search_keyword && search_keyword !== '')
    return {
      search_keyword: `${search_keyword}`
    };
}

export const getIMCID = loginAda => massageAttrVal(AFFILIATE_NUMBER * 100000000000 + Number(loginAda));

const getCartTypes = products => products.map(() => 'personal').map(massageAttrVal);
const getProductBrands = products =>
  products.map(product => product?.productBrandEn ? product?.productBrandEn : product?.productBrand).map(massageAttrVal);
const getProductBVs = products =>
  products.map(product => product?.businessVolume).map(massageAttrVal);
const getProductIds = products => products.map(product => product?.itemCode).map(massageAttrVal);
const getProductNames = products =>
  products.map(product => product?.productNameEn).map(massageAttrVal);
const getProductPVs = products => products.map(product => product?.pointValue).map(massageAttrVal);
const getProductPrices = products => products.map(product => product?.price).map(massageAttrVal);
const getInventoryStatuses = products =>
  products.map(product => product?.productStatus || 'inStock').map(massageAttrVal);
const getProductPromos = products =>
  products.map(product => product?.promotionCode).map(massageAttrVal);

const getOrderId = orderDetails => massageAttrVal(orderDetails?.id);
const getOrderPaymentType = orderDetails =>
  massageAttrVal(PAYMENT_METHODS_MAP[orderDetails?.paymentType] || orderDetails?.paymentType);
const getOrderDeliveryMethod = orderDetails =>
  massageAttrVal(
    DELIVERY_METHODS_MAP[orderDetails?.deliveryMethod] || orderDetails?.deliveryMethod
  );
const getOrderTax = () => massageAttrVal(0);
const getOrderShipping = orderDetails => massageAttrVal(orderDetails?.shipping || 0);
const getOrderPurchaser = products => products.map(product => product?.purchaser).map(getIMCID);

const getProductTransactionIds = products =>
  products.map(product => product?.transactionId).map(massageAttrVal);

const massageAttrVal = val => String(val != null ? val : 'none');

// const PAYMENT_METHODS_MAP = {
//   "0100": "Cash on delivery",
//   "0101": "Wire transfer or ATM transfer",
//   1: "PC Credit card sign-up or debit",
//   8: "PC Credit Card Payment",
//   12: "PC line pay",
//   13: "PC line pay sign-up or debit",
//   2: "Mobile Credit card sign-up or debit",
//   9: "Mobile Credit Card Payment",
//   6: "Mobile line pay",
//   11: "Mobile line pay sign-up or debit",
//   4: "Mobile apple pay",
//   5: "Mobile google pay",
// };

const PAYMENT_METHODS_MAP = {
  1: 'Credit Card',
  2: 'COD',
  3: 'Telegram or ATM Transfer',
  4: 'line pay(bind)',
  5: 'apple pay',
  6: 'cash coupon',
  7: 'line pay',
  13: 'google pay',
  14: 'online',
  15: 'order',
};

const DELIVERY_METHODS_MAP = {
  1: 'HOME_DELIVERY',
  2: 'CENTER_DELIVERY',
  3: 'SUPERMARKET_DELIVERY',
};

export const PAGES = {
  hp: 'HP',
  pdp: 'PDP',
  plp: 'PLP',
  search: 'SEARCH',
  promotion: 'PROMOTION',
  cart: 'CART',
  checkout: 'CHECKOUT',
  confirmation: 'CONFIRMATION',
  promotionList: 'PROMOTIONLIST',
  payment: 'PAYMENT',
  bulkOrder: 'BULKORDER',
  favorites: 'FAVORITES',
  sharedProducts: 'SHAREDPRODUCTS',
  privilege: 'PRIVILEGE',
  memberRenew: 'MEMBERRENEW',
  points: 'POINTS'
};

const PAGE_PROPERTIES = {
  HP: {
    page_category: 'homepage',
    page_subCategory: 'homepage',
    page_name: 'homepage',
    page_section: 'home',
  },
  PDP: {
    page_name: 'product',
    page_section: 'product',
  },
  PLP: {
    page_name: 'category',
    page_section: 'category',
  },
  SEARCH: {
    page_category: 'productsearch',
    page_subCategory: 'productsearch',
    page_name: 'productsearch',
    page_section: 'search',
  },
  PROMOTION: {
    page_category: '首頁',
    page_subCategory: '特惠活動',
    page_name: 'promotion',
    page_section: 'promotion',
  },
  CART: {
    page_category: 'cart',
    page_subCategory: 'cart',
    page_name: 'cart',
    page_section: 'cart',
  },
  CHECKOUT: {
    page_category: 'Checkout Summary Page',
    page_subCategory: 'Checkout Summary Page',
    page_name: 'Checkout Summary Page',
    page_section: 'checkout',
  },
  CONFIRMATION: {
    page_category: 'checkoutorderconfirmation',
    page_subCategory: 'checkoutorderconfirmation',
    page_name: 'checkoutorderconfirmation',
    page_section: 'checkout',
  },
  PROMOTIONLIST: {
    page_category: 'promotion',
    page_subCategory: 'promotion',
    page_name: 'promotion',
    page_section: 'promotion',
  },
  PAYMENT: {
    page_category: 'payment',
    page_subCategory: 'payment',
    page_name: 'payment',
    page_section: 'payment',
  },
};
